import size from "../sizes";
import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Шапка из плотной ткани специально для сезона осень-зима. Аккуратный шов находится на задней части шапки. Запечатывается вся поверхность, в том числе и внутренняя. Приятная в носке и теплая шапка украсит ваш образ в холодное время года.</p><p>Материалы: Футер, 300 гр/кв.м.</p><p>Размеры: 56-59.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`full_print_beanie`]
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
